<template>
    <Dialog>
        <template v-slot:title>{{ $t("message.title_add_ai_setting") }}</template>

        <template v-slot:body>
            <div style="padding-bottom:10px">
                <div style="padding-left:40px;padding-top:10px" v-t="'message.hint_selection_ai_template'"></div>
                <table style="margin-left:20px">
                    <tr>
                        <td v-for="processorTemplate in templates.slice(0, 7)" style="padding-top:10px;padding-bottom:10px">
                            <button class="transparent" type="button" v-on:click="handleChangeSelectTemplate(processorTemplate)">
                                <el-card :shadow="getCardShadowStyle(processorTemplate)" style="{ text-align:center; padding: 0; width: 120px; border-style: none; }">
                                    <img :src="getIcon(processorTemplate)" height="40px" /><br>
                                    <span>{{getLocaledText(processorTemplate.templateName)}}</span>
                                </el-card>
                            </button>
                        </td>
                    </tr>
                    <tr>
                        <td v-for="template in templates.slice(7, 12)" style="padding-top:10px;padding-bottom:10px">
                            <button class="transparent" type="button" v-on:click="handleChangeSelectTemplate(template)">
                                <el-card :shadow="getCardShadowStyle(template)" style="{ text-align:center; padding: 0; width: 120px; border-style: none; }">
                                    <img :src="getIcon(template)" height="40px" /><br>
                                    <span>{{getLocaledText(template.templateName)}}</span>
                                </el-card>
                            </button>
                        </td>
                    </tr>
                </table>

                <div v-if="!redraw">
                    <AiAppSettingDefinitionEditForm
                        v-model="form"
                        :settingTitle="settingTitle"
                        :helpHtmlUrl="helpHtmlUrl"
                        @update:valid ="setButtonStatus($event)"
                    />
                </div>
            </div>
        </template>

        <template v-slot:button>
            <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_back'"></el-button>
            <el-button class="dialog-ok-button" @click="save" :disabled="disableSave" v-t="'message.button_save'"></el-button>
        </template>
    </Dialog>
</template>

<script>
import constants from "@/components/constants";
import commonUtil from "@/components/commonutil";
import processorTemplateUtil from "@/components/pc/setting/ai-app/AiAppSettingUtil";
import Dialog from "@/components/pc/common/Dialog";
import AiAppSettingUtility from "@/components/pc/setting/ai-app/AiAppSettingUtility";
import AiAppSettingDefinitionEditForm from "@/components/pc/setting/ai-app/AiAppSettingDefinitionEditForm";

export default {
    mixins:[ AiAppSettingUtility ],

    components: { Dialog, AiAppSettingDefinitionEditForm },

    props: {
        processorTemplateList: {
            type: Array,
            required: true
        }
    },

    data() {
        return {
            templates: [],
            form: {
                displayName: null,
                sections: null
            },
            selectedTemplate: null,
            redraw: true,
            disableSave: true,
        };
    },

    computed: {
        settingTitle() {
            return this.getSettingTitle(this.selectedTemplate.templateName)
        },
        helpHtmlUrl() {
            return this.getHelpHtmlUrl(this.selectedTemplate.helpHtml)
        }
    },

    created: function() {
        if (this.processorTemplateList.length > 0) {
            for (let processorTemplate of this.processorTemplateList) {
                const helpHtml = 'helpHtml' in processorTemplate.template ? processorTemplate.template['helpHtml'] : null
                const iconUrl =  'iconUrl' in processorTemplate.template ? processorTemplate.template['iconUrl'] : null

                const template = {
                    type: AiAppSettingUtility.TYPE_PROCESSOR,
                    id : processorTemplate.id,
                    templateName : processorTemplate.template['name'],
                    displayName : this.getLocaledText(processorTemplate.template['defaultDisplayName']),
                    // displayNameValidator : processorTemplateUtil.getDisplayNameValidator(),
                    helpHtml : helpHtml,
                    iconUrl : iconUrl,
                    sections : processorTemplate.template['processors']
                }

                this.templates.push(template)
            }
        }

        /* No longer offered
        const serviceInformationTemplate = {
            type: AiAppSettingUtility.TYPE_SERVICE_INFORMATION,
            id: AiAppSettingUtility.SERVICE_NAME_GIGARAKU_CAMERA,
            templateName : {
                en : 'Cloud Camera',
                ja : 'クラウドカメラ'
            },
            displayName: 'クラウドカメラ連携:',
            iconUrl : null,
            sections: [
                {
                    name: {
                        en: 'Collaboration　setting (Buddycom)',
                        ja: '連携設定(Buddycom)'
                    },
                    parameters: [
                        {
                            selectUser: true,
                            jsonKey: "senderName",
                            title: {
                              en: 'Notification user',
                              ja: '通知用ユーザ-'
                            },
                            type: "text",
                            disabled: true,
                            value: null,
                            validationRule: "reqHalfWideLetter"
                        }
                    ]
                },
                {
                    name: {
                        en: 'Collaboration　setting (Cloud camera)',
                        ja: '認証メールアドレス設定'
                    },
                    parameters: [
                        {
                            jsonKey: "authenticationEmail",
                            title: {
                                en: 'Email address　for authentication',
                                ja: '認証用メールアドレス'
                            },
                            type: "text",
                            disabled: false,
                            value: null,
                            validationRule: "emailAddress"
                        }
                    ]
                }
            ]
        }

        this.templates.push(serviceInformationTemplate)
        */

        this.handleChangeSelectTemplate(this.templates[0])
    },

    methods: {
        getCardShadowStyle(processorTemplate) {
            if (processorTemplate === this.selectedTemplate) {
                return "always"
            } else {
                return "hover"
            }
        },
        getIcon(template) {
            if ('iconUrl' in template) {
                if (template['iconUrl'] != null) {
                    return template.iconUrl;
                } else {
                    return processorTemplateUtil.getDefaultIconUrl()
                }
            }
            return processorTemplateUtil.getDefaultIconUrl();
        },
        handleChangeSelectTemplate(template) {
            if (this.selectedTemplate == null || template.templateName !== this.selectedTemplate.templateName) {
                this.selectedTemplate = template
                this.form.displayName = template.displayName
                this.form.sections = JSON.parse(JSON.stringify(template.sections))  // deep copy through JSON

                this.setButtonStatus(false)
                this.redraw = true;
                let self = this;
                this.$nextTick(function() {
                    self.redraw = false;
                });
            }
        },
        setButtonStatus(valid) {
            this.disableSave = !valid
        },
        save() {
            const self = this

            if (this.selectedTemplate.type === AiAppSettingUtility.TYPE_PROCESSOR) {
                this.$emit('save', '/createprocessordefinition', {
                    templateId: this.selectedTemplate.id,
                    displayName: this.form.displayName,
                    fulfilledTemplate: {
                        processors : this.form.sections
                    }
                });
            } else if (this.selectedTemplate.type === AiAppSettingUtility.TYPE_SERVICE_INFORMATION) {
                let value = {};
                value['displayName'] = this.form.displayName
                for (let section of this.form.sections) {
                    for (let parameter of section.parameters) {
                        value[parameter.jsonKey] = parameter.value
                    }
                }

                this.$emit(
                    'save',
                    '/createserviceinformation',
                    {
                        serviceName: this.selectedTemplate.id,
                        generateId: true,
                        value: value
                    },
                    (data) => {
                        if (data.status === constants.STATUS_ERROR_AUTH_FAILED) {
                            commonUtil.notifyMessage(self, 'Error', commonUtil.getMessageText(self.$i18n, "error_cannot_find_token"));
                        }
                    }
                )
            }

        }
    }
}
</script>

<style scoped>

.is-always-shadow
{
    background-color: #ecf1fa;
}
.is-hover-shadow:hover
{
    background-color: #ecf1fa;
}

</style>
